export const VIKI_IMG = {
  idle: "/viki/viki-idle.png",
  thinking: "/viki/viki-thinking.png",
  wave: "/viki/viki-wave.png",
  happy: "/viki/viki-happy.png",
};

// Avatar "vestiti" a tema: VIKI indossa davvero gli accessori dell'app
// (visiera verde+occhiali+papillon da contabile, cappello+borsa da
// postino, elmetto giallo da produzione).
export const VIKI_THEME_IMG = {
  finanza: "/viki/viki-contabile.png",
  postino: "/viki/viki-postino.png",
  produzione: "/viki/viki-produzione.png",
  natale: "/viki/viki-natale.png",
  estate: "/viki/viki-estate.png",
  helpdesk: "/viki/viki-sohelp.png",
  commerciale: "/viki/viki-paqway.png",
};

// Tema stagionale: a Natale (1 dic – 6 gen) e ad agosto VIKI si veste a
// festa ovunque, con priorità sul tema dell'app.
export const seasonalTheme = (d = new Date()) => {
  const m = d.getMonth() + 1;
  if (m === 12 || (m === 1 && d.getDate() <= 6)) return "natale";
  if (m === 8) return "estate";
  return null;
};

export const THEME_FOR_APP = {
  contabilita: "finanza",
  tesoreria: "finanza",
  paghe: "finanza",
  posta: "postino",
  produzione: "produzione",
  sohelp: "helpdesk",
  paqway: "commerciale",
};

export const VikiAvatar = ({ size = 36, mood = "idle", theme = null, float = false, glow = false, style }) => (
  <span style={{ position: "relative", display: "inline-flex", width: size, height: size + (glow ? 8 : 0), flexShrink: 0, ...style }}>
    <img
      src={VIKI_THEME_IMG[seasonalTheme() || theme] || VIKI_IMG[mood] || VIKI_IMG.idle}
      alt="V.I.K.I."
      width={size}
      height={size}
      draggable={false}
      className={`${float ? "viki-floaty" : ""} ${mood === "thinking" ? "viki-tilt" : ""}`}
      style={{ objectFit: "contain", pointerEvents: "none", filter: "drop-shadow(0 4px 10px rgba(0,0,0,0.45))" }}
    />
    {glow && <span className="viki-glow-ellipse" />}
  </span>
);
